import React from 'react';
import { Table } from 'antd';
import {
  accessLevelLabel,
  EAccessLevel,
  EPermissionTab,
  IProfile,
  permissionTabLabel,
} from 'entities/Permission/Permission.models';

interface IComponentProps {
  profile?: IProfile;
}

interface IRow {
  key: string;
  tab: string;
  level: string;
}

// Read-only preview of a profile's tab -> access-level matrix. Every catalog tab is shown so the
// reviewer sees explicit "No Access" rows, not just the granted ones.
export const ProfilePreview: React.FC<IComponentProps> = ({ profile }) => {
  if (!profile) {
    return null;
  }

  const rows: IRow[] = Object.values(EPermissionTab).map((tab) => {
    const level = profile.matrix[tab] ?? EAccessLevel.NoAccess;

    return {
      key: tab,
      tab: permissionTabLabel[tab],
      level: accessLevelLabel[level as EAccessLevel],
    };
  });

  return (
    <Table<IRow>
      size="small"
      pagination={false}
      dataSource={rows}
      columns={[
        { title: 'Module', dataIndex: 'tab', key: 'tab' },
        { title: 'Access', dataIndex: 'level', key: 'level' },
      ]}
    />
  );
};
